<template>
  <div class="iotplt-card-box" style="min-height: 320px">
    <a-empty description="功能开发中" />
  </div>
</template>

<script>
export default {
  name: 'SalesInventoryCheckSimCards'
}
</script>
